import * as React from 'react';
import Spinner from './index.mjs';
import BaseComponent from '../Element/component.mjs';

/**
 * Represents a spinning icon.
 */
class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.elementClass = Spinner;
    }
    render() {
        // @ts-ignore
        return React.createElement("svg", { ref: this.attachElement });
    }
}
Component.ctor = Spinner;
var Component$1 = Component;

export { Component$1 as default };
